import axios from "axios";
import { BASE_URL } from "../../Helper/Helper";

const FollowClientState = {
  addFollowClient: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v1/admin/create-follow-client`,
      requestOptions,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      },
    );

    let datas = response.data.data;
    return datas;
  },

  getFollowClient: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v1/admin/get-follow-client/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      },
    );

    //console.log("response", response);
    let datas = response.data.data;
    //console.log("datas", datas);
    return datas;
  },

  updateFollowClient: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    await axios.put(
      `${BASE_URL}/api/v1/admin/update-follow-client/${id}`,
      requestOptions,
    );
  },

  deleteFollowClient: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v1/admin/delete-follow-client/${id}`,
      {
        headers: {
          "auth-token": localStorage.getItem("token"),
        },
      },
    );

    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default FollowClientState;
